import { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { mangaList, featuredMangaIds } from '@/mocks/manga';

export default function FeaturedSlider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const featured = mangaList.filter((m) => featuredMangaIds.includes(m.id));

  const startAutoPlay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % featured.length);
    }, 5000);
  };

  useEffect(() => {
    startAutoPlay();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [featured.length]);

  const current = featured[activeIndex];

  if (!current) return null;

  return (
    <section className="relative h-[480px] md:h-[580px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60 z-10"></div>
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${current.coverImage})` }}
      ></div>
      <div className="relative z-20 max-w-7xl mx-auto px-4 md:px-6 h-full flex items-center">
        <div className="w-full max-w-xl">
          <div className="flex items-center gap-2 mb-4">
            <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
              推荐
            </span>
            <span className="text-xs px-2.5 py-1 rounded-full bg-background-50/20 text-background-50 whitespace-nowrap">
              {current.category}
            </span>
            <span className="text-xs text-background-50/80 whitespace-nowrap">
              <i className="ri-star-fill text-yellow-400 text-[10px] mr-0.5"></i>
              {current.rating}
            </span>
          </div>
          <h1 className="text-3xl md:text-5xl font-heading font-semibold text-background-50 leading-tight">
            {current.title}
          </h1>
          <p className="text-sm md:text-base text-background-50/80 mt-3 line-clamp-2">
            {current.originalTitle}
          </p>
          <p className="text-sm text-background-50/70 mt-4 line-clamp-3 leading-relaxed">
            {current.description}
          </p>
          <div className="flex items-center gap-4 mt-6">
            <NavLink
              to={`/article/${current.id}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line"></i>
              开始阅读
            </NavLink>
            <span className="text-sm text-background-50/70 whitespace-nowrap">
              共 {current.chapters} 话 · {current.views.toLocaleString()} 次阅读
            </span>
          </div>
          <div className="flex items-center gap-2 mt-8">
            {featured.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setActiveIndex(index);
                  startAutoPlay();
                }}
                className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                  index === activeIndex ? 'w-8 bg-accent-500' : 'w-4 bg-background-50/40 hover:bg-background-50/60'
                }`}
                aria-label={`切换到第 ${index + 1} 张`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}